/**
 * Redondea hacia abajo al múltiplo de 100 más cercano.
 * Ej.: 820 → 800, 11850 → 11800.
 */
export function floorToHundred(value: number): number {
  if (!Number.isFinite(value) || value <= 0) {
    return 0;
  }
  return Math.floor(value / 100) * 100;
}

/** Prefijo de aliados: total real − 1 (mínimo 0). */
export function aliadosDisplayCount(totalConDesembolso: number): number {
  if (!Number.isFinite(totalConDesembolso) || totalConDesembolso <= 0) {
    return 0;
  }
  return Math.max(0, Math.floor(totalConDesembolso) - 1);
}

/** Separador de miles estilo Colombia (punto). */
export function formatEsCoInteger(value: number): string {
  return Math.floor(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function formatMunicipiosValue(ciudadesAtendidas: number): string {
  const total = Number.isFinite(ciudadesAtendidas) ? Math.max(0, Math.floor(ciudadesAtendidas)) : 0;
  // < 100: número real (ambientes con poca cobertura); ≥ 100: tramos de 100.
  const display = total < 100 ? total : floorToHundred(total);
  return `+${formatEsCoInteger(display)}`;
}

/**
 * Monto en millones COP → tramos de 100 M con prefijo + y signo $.
 * Ej.: 11850 → "+ $11.800 M"
 */
export function formatMontoValue(millones: number): string {
  const rounded = floorToHundred(millones);
  return `+ $${formatEsCoInteger(rounded)} M`;
}

export function formatAliadosEnTexto(totalConDesembolso: number): string {
  return `+${formatEsCoInteger(aliadosDisplayCount(totalConDesembolso))}`;
}
